import { render, staticRenderFns } from "./AgentsRightsTable.vue?vue&type=template&id=93b6043e&scoped=true&"
import script from "./AgentsRightsTable.vue?vue&type=script&lang=js&"
export * from "./AgentsRightsTable.vue?vue&type=script&lang=js&"
import style0 from "./AgentsRightsTable.vue?vue&type=style&index=0&id=93b6043e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b6043e",
  null
  
)

export default component.exports